'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./enums-de2d9d36.js');
var useOnClickOutside_hook = require('./use-on-click-outside.hook-fa9c21ca.js');

var positionStyles = {
    top: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    bottom: 100%;\n    margin-bottom: 8px;\n  "], ["\n    bottom: 100%;\n    margin-bottom: 8px;\n  "]))),
    right: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    left: 100%;\n    margin-left: 8px;\n  "], ["\n    left: 100%;\n    margin-left: 8px;\n  "]))),
    bottom: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    top: 100%;\n    margin-top: 8px;\n  "], ["\n    top: 100%;\n    margin-top: 8px;\n  "]))),
    left: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    right: 100%;\n    margin-right: 8px;\n  "], ["\n    right: 100%;\n    margin-right: 8px;\n  "]))),
};
var horizontalAlignmentStyles = {
    start: styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    left: 0;\n  "], ["\n    left: 0;\n  "]))),
    center: styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    left: 50%;\n    transform: translateX(-50%);\n  "], ["\n    left: 50%;\n    transform: translateX(-50%);\n  "]))),
    end: styled.css(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n    right: 0;\n  "], ["\n    right: 0;\n  "]))),
    stretch: styled.css(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n    left: 0;\n    right: 0;\n  "], ["\n    left: 0;\n    right: 0;\n  "]))),
};
var verticalAlignmentStyles = {
    start: styled.css(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n    top: 0;\n  "], ["\n    top: 0;\n  "]))),
    center: styled.css(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n    top: 50%;\n    transform: translateY(-50%);\n  "], ["\n    top: 50%;\n    transform: translateY(-50%);\n  "]))),
    end: styled.css(templateObject_11 || (templateObject_11 = tslib_es6.__makeTemplateObject(["\n    bottom: 0;\n  "], ["\n    bottom: 0;\n  "]))),
    stretch: styled.css(templateObject_12 || (templateObject_12 = tslib_es6.__makeTemplateObject(["\n    top: 0;\n    bottom: 0;\n  "], ["\n    top: 0;\n    bottom: 0;\n  "]))),
};
var alignmentStyles = {
    top: horizontalAlignmentStyles,
    right: verticalAlignmentStyles,
    bottom: horizontalAlignmentStyles,
    left: verticalAlignmentStyles,
};
var PopoverBody = styled__default.div(templateObject_13 || (templateObject_13 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n\n  ", "\n  ", "\n"], ["\n  position: absolute;\n\n  ", "\n  ", "\n"])), function (_a) {
    var position = _a.position;
    return positionStyles[position];
}, function (_a) {
    var position = _a.position, alignment = _a.alignment;
    return alignmentStyles[position][alignment];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;

var PopoverWrapper = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n"], ["\n  position: relative;\n  display: inline-block;\n"])));
var templateObject_1$1;

var Popover = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, wrapperClassName = _a.wrapperClassName, open = _a.open, buttonComponent = _a.buttonComponent, children = _a.children, position = _a.position, bodyRef = _a.bodyRef, alignment = _a.alignment, dataCy = _a.dataCy, handleClose = _a.onClose, wrapperDataCy = _a.wrapperDataCy, wrapperDataTestId = _a.wrapperDataTestId, ignoreClickOnClasses = _a.ignoreClickOnClasses, checkItemClass = _a.checkItemClass, ignoreOnClickOutside = _a.ignoreOnClickOutside;
    var menuRef = React.useRef(null);
    useOnClickOutside_hook.useOnClickOutside(function () {
        if (open && handleClose && !ignoreOnClickOutside) {
            handleClose();
        }
    }, [menuRef], ignoreClickOnClasses, checkItemClass);
    return (React__default.createElement(PopoverWrapper, { ref: menuRef, className: wrapperClassName, "data-cy": wrapperDataCy, "data-testid": wrapperDataTestId },
        buttonComponent,
        open && (React__default.createElement(PopoverBody, { ref: bodyRef, className: "popover-body " + className, position: position, alignment: alignment, "data-cy": dataCy }, children))));
};

exports.Popover = Popover;
